import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import articles from '@/content/articles';

interface MonthGroup {
  key: string;
  label: string;
  count: number;
  items: typeof articles;
}

function groupByMonth(): MonthGroup[] {
  const buckets = new Map<string, typeof articles>();

  for (const a of articles) {
    const key = a.date.slice(0, 7);
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key)!.push(a);
  }

  return Array.from(buckets.entries())
    .sort((a, b) => b[0].localeCompare(a[0]))
    .map(([key, items]) => {
      const [year, month] = key.split('-');
      const label = `${year} 年 ${Number(month)} 月`;
      return { key, label, count: items.length, items };
    });
}

export default function BlogArchive() {
  const groups = groupByMonth();

  return (
    <div className="min-h-screen bg-white">
      <Navbar solid />

      <main className="pt-28 pb-20 px-6 md:px-10 max-w-3xl mx-auto">
        <div className="mb-10">
          <Link
            to="/blog"
            className="text-sm text-[#94A3B8] hover:text-[#0F172A] transition-colors inline-flex items-center gap-1 mb-3"
          >
            <i className="ri-arrow-left-s-line" />
            返回洞察
          </Link>
          <h1
            className="text-2xl font-bold text-[#0F172A]"
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            文章归档
          </h1>
          <p className="mt-2 text-sm text-[#94A3B8]">共 {articles.length} 篇</p>
        </div>

        <div className="flex flex-col gap-12">
          {groups.map((g) => (
            <section key={g.key}>
              <h2
                className="text-base font-medium text-[#0F172A] mb-4 pb-2 border-b border-slate-200"
                style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
              >
                {g.label}
                <span className="ml-2 text-sm text-[#94A3B8] font-normal">（{g.count} 篇）</span>
              </h2>

              <div className="flex flex-col divide-y divide-slate-100">
                {g.items.map((a) => (
                  <Link
                    key={a.slug}
                    to={`/blog/${a.slug}`}
                    className="group py-4 first:pt-0 last:pb-0 cursor-pointer"
                  >
                    <p
                      className="text-base font-medium text-[#0F172A] group-hover:text-[#F97316] transition-colors leading-relaxed"
                      style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
                    >
                      {a.title}
                    </p>
                    <p className="mt-1.5 text-sm text-[#94A3B8]">{a.date}</p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
